import React, { MouseEvent } from 'react';

import { Icon } from '../Icon';

export interface ActionButtonProps {
  /**
   * sets aria-label for the button
   */
  'aria-label': string;
  /**
   * sets href for the link
   */
  href?: string;
  /**
   * sets the icon name into the Icon component
   */
  iconName: string;
  /**
   * Sets id for the button, to show or hide companion action button
   */
  id?: string;
  /**
   * sets the onClick event for the button
   */
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export function ActionButton({
  'aria-label': ariaLabel,
  href,
  iconName,
  id,
  onClick,
}: ActionButtonProps) {
  return (
    <div className="fd-shellbar__action fd-shellbar__action--desktop">
      {href ? (
        <a
          aria-label={ariaLabel}
          className="fd-button fd-button--transparent fd-shellbar__button"
          href={href}
          id={id}
          referrerPolicy="no-referrer"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon
            accessibleName={iconName}
            mode="Decorative"
            name={iconName}
            role="presentation"
          />
        </a>
      ) : (
        <button
          aria-label={ariaLabel}
          className="fd-button fd-button--transparent fd-shellbar__button"
          id={id}
          onClick={onClick}
          type="button"
        >
          <Icon
            accessibleName={iconName}
            mode="Decorative"
            name={iconName}
            role="presentation"
          />
        </button>
      )}
    </div>
  );
}
